import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PttPinComponent } from '@nttp/core-ui';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { PinCodeService } from '@pg-app/auth/services/pin-code.service';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-login-step2',
  templateUrl: './login-step2.component.html',
  styleUrls: ['./login-step2.component.scss']
})
export class LoginStep2Component implements OnInit, AfterViewInit {
  pinCodeForm: FormGroup;
  showError = false;
  phoneNumber = '';
  PIN_CODE_LENGTH = 6;
  portalId = '';
  isPrivalgoMarkets = environment.isPrivalgoMarkets;
  brandName = environment.brandName;
  domain = environment.domain;

  @ViewChild(PttPinComponent, { static: true })
  pttPin: PttPinComponent;

  get pin(): FormControl {
    return this.pinCodeForm.get('pin') as FormControl;
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private pinCodeService: PinCodeService,
    private loginInfo: LoginInfoService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.pinCodeForm = this.fb.group({
      pin: ['', [Validators.required, Validators.minLength(this.PIN_CODE_LENGTH)]]
    });

    this.portalId = this.loginInfo.portalId;
  }

  ngAfterViewInit() {
    if (this.pttPin) {
      this.pttPin.setFocus();
      this.cdr.detectChanges();
    }
  }

  onSubmit() {
    const value = this.pin.value;
    if (this.pinCodeForm.valid) {
      this.pinCodeService
        .verifyPin({
          pincode: value,
          userId: this.loginInfo.userId,
          IsTryAgain: false,
          portalId: this.portalId,
          verificationType: VerifyTypeSendCodeEnum.Onetouch,
          sendVerificationCode: false
        })
        .subscribe(
          res => {
            this.loginInfo.currentUserStep = 'step-3';
            this.loginInfo.userId = res.userId;
            this.loginInfo.pinCode = value;
            this.loginInfo.portalId = res.portalId;
            this.router.navigate(['/auth/login/step-3']);
          },
          err => {
            this.showError = true;
            this.pinCodeForm.patchValue({
              pin: ''
            });
            if (err && err.error && err.error.responseData && err.error.responseData.isUserLocked === true) {
              this.router.navigate(['auth/login/reactivate-account']);
            }
          }
        );
    } else {
      this.showError = true;
      this.pinCodeForm.patchValue({
        pin: ''
      });
    }
  }
}
